import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aade37f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard__container" }
const _hoisted_2 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_3 = { class: "profile-creation-wizard__content" }
const _hoisted_4 = { class: "details-form__item" }
const _hoisted_5 = { class: "custom-font-text" }
const _hoisted_6 = { class: "profile-creation-wizard__content-footer" }

import {reactive, ref, inject, computed, onBeforeMount, onMounted, onBeforeUnmount} from 'vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {useStore} from 'vuex';
    import {useRouter} from 'vue-router';
    import {useTranslation} from '@malt/vue3-use';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';
    import IndustryExpertiseSide from '@/profile-creation-wizard/components/for-creation/ui/industrySkills/IndustryExpertiseSide.vue';
    import IndustryExpertise from '@/common/components/industry-expertise/IndustryExpertise.vue';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import mutations from '@/profile-creation-wizard/components/for-creation/store/mutations';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {IndustrySkill} from '@/profile-creation-wizard/components/for-creation/store';
    import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';

    const maxSelection = 5;

    
export default /*#__PURE__*/_defineComponent({
  __name: 'IndustryExpertiseStep',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();

    const industryExpertiseRepository = inject(DI.industryExpertiseRepository);

    const creationForm = ref(store.getters[getters.creationForm]);
    const industry = ref<HTMLElement>(null);

    const stepName = computed(() => router.currentRoute.value.name);
    const meta = computed(() => router.currentRoute.value.meta);
    const progressPercentage = computed(() => meta.value.progressPercentage);
    const isStrategyFunnel = computed(() => meta.value.funnelMode === ProfileCreationFunnelMode.STRATEGY);
    const isStepValid = computed(() => (isStrategyFunnel.value ? creationForm.value.industryExpertises.length > 0 : true));
    const stepNavigator = new StepNavigator(router, meta.value.previousStep, meta.value.nextStep);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    const state = reactive<{expertiseAvailable: IndustrySkill[]; isResponsive: boolean}>({
        expertiseAvailable: [],
        isResponsive: isAtResponsiveBreakpoint(),
    });

    onBeforeMount(async (): Promise<void> => {
        if (window.hj) {
            // Custom event Hotjar
            window.hj('event', 'profile_creation_details_page');
        }
        window.addEventListener('resize', refreshResponsive);
        await loadExpertisesAvailable();
    });

    onMounted((): void => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer('#details-industry-bottom-sheet', '', industry.value, 'div.profile-creation-wizard');
        bottomSheetDisplayer.value.mounted();
    });

    onBeforeUnmount((): void => window.removeEventListener('resize', refreshResponsive));

    async function loadExpertisesAvailable(): Promise<void> {
        const [expertises, error] = await industryExpertiseRepository!.loadExpertise();
        if (expertises && !error) {
            state.expertiseAvailable = expertises;
        }
    }

    function goToPrevious(): void {
        stepNavigator.previous();
    }

    function goNext(): void {
        if (isStepValid.value) {
            stepNavigator.next();
        }
    }

    function handleExpertisesChanged(expertises: IndustrySkill[]) {
        store.commit(mutations.updateIndustryExpertises, expertises);
    }

    function handleMaxSelectionReached() {
        pushNotification(msg('profile.creation.completion.wizard.industry.expertise.error.limit', maxSelection), {level: 'error'});
    }

    function refreshResponsive(): void {
        state.isResponsive = isAtResponsiveBreakpoint();
    }

    function isAtResponsiveBreakpoint(): boolean {
        return window.innerWidth < 996;
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "industry",
    ref: industry,
    class: "profile-creation-wizard ff-bottom-fixed-cta"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_joy_progress_bar, { percentage: progressPercentage.value }, null, 8, ["percentage"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(StepMobileHeader, {
            "step-name": stepName.value,
            "onClick:previous": goToPrevious
          }, null, 8, ["step-name"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(StepItemTitle, {
              "is-optional": !isStrategyFunnel.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.industry.expertise.title')), 1)
              ]),
              _: 1
            }, 8, ["is-optional"]),
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.industry.expertise.regular.subtitle')), 1),
              _createElementVNode("a", {
                class: "open-bottom-sheet",
                onClick: openBottomSheet
              }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.industry.expertise.title')), 1)
            ]),
            _createVNode(IndustryExpertise, {
              responsive: state.isResponsive,
              "all-expertises": state.expertiseAvailable,
              "selected-expertises": creationForm.value.industryExpertises,
              "max-selection": maxSelection,
              "onIndustryExpertise:updated": handleExpertisesChanged,
              "onIndustryExpertise:maxSelectionReached": handleMaxSelectionReached
            }, null, 8, ["responsive", "all-expertises", "selected-expertises"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_joy_progress_bar, {
            percentage: progressPercentage.value,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(StepActions, {
            "step-name": stepName.value,
            "is-disabled-button-next": !isStepValid.value,
            "show-button-skip": !isStrategyFunnel.value,
            "onClick:next": goNext,
            "onClick:skip": goNext,
            "onClick:previous": goToPrevious
          }, null, 8, ["step-name", "is-disabled-button-next", "show-button-skip"])
        ])
      ]),
      _createVNode(IndustryExpertiseSide)
    ])
  ], 512))
}
}

})